module.exports = __webpack_public_path__ + "static/img/敬請期待300.a60613ed.png";